export default __webpack_public_path__ + "static/media/minus-circle.ca80f594.svg";